export const supplierTabs = [
  {
    title: '成交供应商', name: '1'
  }, {
    title: '潜在供应商', name: '2'
  }, {
    title: '黑名单', name: '3'
  }
]
export const supplierNameList = [
  { value: 'suName', label: '供应商名称' },
  { value: 'suType', label: '供应商类型' },
  { value: 'accountBalance', label: '可用余额' },
  { value: 'supplierTradeAmount', label: '贸易总额' },
  { value: 'contractNumber', label: '合同总数' },
  { value: 'suContacts', label: '联系人' },
  { value: 'suPhone', label: '电话' },
  { value: 'suMobile', label: '手机' }
]
export const supplierEditTabs = [
  {
    title: '供应商资料', name: 'supplierInformation'
  }, {
    title: '合同清单', name: 'contractList'
  }, {
    title: '付款记录', name: 'paymentRecord'
  }, {
    title: '充值记录', name: 'rechargeRecord'
  }
]

export const contractCard = [
  {
    title: '全部', name: 'all'
  }, {
    title: '待签署', name: 'waitSign'
  }, {
    title: '履行中', name: 'signUnderway'
  }, {
    title: '已履行', name: 'execute'
  }, {
    title: '已作废', name: 'cancellation'
  }
]
export const quoteDetailList = [
  { name: '供应商名称', value: 'suName' },
  { name: '品牌', value: 'brandName' },
  { name: '型号', value: 'proModel' },
  { name: '订货号', value: 'proOrdernum' },
  { name: '添加人', value: 'createUser' },
  { name: '来源', value: 'source' }
]
export const quoteCollectList =
[
  { name: '供应商名称', value: 'suName' },
  { name: '过期报价', value: 'pastCount' },
  { name: '对接类型', value: 'interfaceType' },
  { name: '负责人', value: 'staffUsename' }
]
export const quoteCollectTable =
[
  { name: '供应商名称', id: 1, allocation: '分配负责人' },
  { name: '过期报价', id: 2, allocation: '分配负责人' },
  { name: '对接类型', id: 3, allocation: '分配负责人' },
  { name: '负责人', id: 4, allocation: '分配负责人' },
  { name: '负责人', id: 4, allocation: '分配负责人' },
  { name: '负责人', id: 4, allocation: '分配负责人' },
  { name: '负责人', id: 4, allocation: '分配负责人' },
  { name: '负责人', id: 4, allocation: '分配负责人' }
]
// export const quoteConfigTable =
// [
//   { name: '供应商名称', id: 1 },
//   { name: '过期报价', id: 2 },
//   { name: '对接类型', id: 3 },
//   { name: '负责人', id: 4 }
// ]
export const activityList = [
  { name: '供应商名称', id: 1 },
  { name: '活动状态', id: 2 }
]

export const checkboxGroupList = [
  { label: '银行转账', id: 1 },
  { label: '承兑汇票', id: 2 },
  { label: '抵扣金额', id: 3 }
]

export const sumSelector = [
  { name: '银行转账：', id: 1 },
  { name: '承兑汇票：', id: 2 }
]

// 客户报价-清空报价
export const emptyList = [
  { label: '有效报价', id: 1 },
  { label: '过期报价', id: 2 },
  { label: '询价报价', id: 3 },
  { label: '导入报价', id: 4 },
  { label: '期货报价', id: 5 },
  { label: '现货报价', id: 6 },
  { label: '全部报价', id: 7 }

]
